import { useDispatch, useSelector } from "react-redux";
import styles from "./GuideVideoView.module.css";
import { editorActions } from "../../../store/editor";
import { fotActions } from "../../../store/fot";
import { logEvent } from "@uikit/service/amplitude";
import { useEffect, useRef, useState } from "react";
import { isEmpty } from "lodash";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import React from "react";

const defaultVideo = "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial.mp4";
const cotVideo = "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/tutorial_v3.webm";
export default React.memo(function GuideVideoView(props) {
  const guideVideoRef = useRef(null);
  const dispatch = useDispatch();

  const imagicaStudioTutorial = useSelector(state => state.fot.imagicaStudioTutorial);
  const optimizeGuideVideo = useSelector(state => state.editor.optimizeGuideVideo);
  const setOptimizeGuideVideo = val => {
    dispatch(editorActions.setOptimizeGuideVideo(val));
  };

  const [guideVideo, setGuideVideo] = useState("");

  const tutorialSessionId = useSelector(state => state.fot.tutorialSessionId);
  const setTutorialSessionId = val => {
    dispatch(fotActions.setTutorialSessionId(val));
  };

  const setCurrentGuideTitlePage = val => {
    dispatch(editorActions.setCurrentGuideTitlePage(val));
  };
  const setShowGuideVideo = val => {
    dispatch(editorActions.setShowGuideVideo(val));
  };

  const clickCloseIcon = () => {
    guideVideoRef.current.pause();
    guideVideoRef.current.currentTime = "0";
    setShowGuideVideo(false);

    // 其他视频播放后不弹出引导页的提示
    if (!isEmpty(optimizeGuideVideo)) {
      setOptimizeGuideVideo("");
      return;
    }
    setCurrentGuideTitlePage("end");
    logEvent("close_onboarding_video");
  };

  useEffect(() => {
    if (imagicaStudioTutorial.showCotGuide) {
      setGuideVideo(cotVideo);
    }
  }, [imagicaStudioTutorial.showCotGuide]);

  useEffect(() => {
    if (imagicaStudioTutorial.showManualGuide) {
      setGuideVideo(defaultVideo);
    }
  }, [imagicaStudioTutorial.showManualGuide]);

  useEffect(() => {
    if (isEmpty(guideVideoRef.current)) return;
    guideVideoRef.current.volume = 0.5;
    guideVideoRef.current.addEventListener(
      "ended",
      function () {
        // 非引导页播放完毕暂不关闭
        if (!isEmpty(optimizeGuideVideo)) return;
        clickCloseIcon();
      },
      false
    );
  }, [guideVideoRef]);

  useEffect(() => {
    if (props.showGuideVideo) {
      guideVideoRef.current.play();
    }
  }, [props.showGuideVideo]);

  const activeVideoUrl = optimizeGuideVideo || guideVideo;

  return (
    <div className={styles.guideVideo} style={props.showGuideVideo ? null : { display: "none" }}>
      <div className={styles.videobox}>
        <span className={`${styles["iconClose"]}`} onClick={clickCloseIcon}>
          <img
            src={`${settings.S3CDN}${settings.viewAssetsPath}ACAEB5Cross.svg`}
            alt=""
            data-amplitude={"close_example_video:"}
          />
        </span>

        <div>
          <video
            ref={guideVideoRef}
            controls
            // autoPlay
            width="100%"
            height="100%"
            src={activeVideoUrl}
          ></video>
        </div>
      </div>
    </div>
  );
});
